"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LakeMarineris = void 0;
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var constants_1 = require("../../constants");
var PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var PlaceOceanTile_1 = require("../../deferredActions/PlaceOceanTile");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var LakeMarineris = (function (_super) {
    __extends(LakeMarineris, _super);
    function LakeMarineris() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.LAKE_MARINERIS,
            cost: 18,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.temperature(0); }),
            metadata: {
                cardNumber: '053',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) { return b.oceans(2); }),
                description: 'Requires 0° C or warmer. Place 2 ocean tiles.',
                victoryPoints: 2,
            },
        }) || this;
    }
    LakeMarineris.prototype.canPlay = function (player) {
        if (!_super.prototype.canPlay.call(this, player)) {
            return false;
        }
        var remainingOceans = constants_1.MAX_OCEAN_TILES - player.game.board.getOceansOnBoard();
        var oceansPlaced = Math.min(remainingOceans, 2);
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS)) {
            return player.canAfford(player.getCardCost(this) + constants_1.REDS_RULING_POLICY_COST * oceansPlaced);
        }
        return true;
    };
    LakeMarineris.prototype.play = function (player) {
        player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player, 'Select space for first ocean'));
        player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player, 'Select space for second ocean'));
        return undefined;
    };
    LakeMarineris.prototype.getVictoryPoints = function () {
        return 2;
    };
    return LakeMarineris;
}(Card_1.Card));
exports.LakeMarineris = LakeMarineris;
//# sourceMappingURL=LakeMarineris.js.map